function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import defaultProps from '../default-props';

const UndrawCreditCardPayment = _props => {
  const props = Object.assign({}, _props);
  const primaryColor = props.primaryColor || defaultProps.primaryColor;
  const style = Object.assign({
    height: props.height || defaultProps.height,
    width: '100%'
  }, props.style);
  delete props.primaryColor;
  delete props.height;
  delete props.style;
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    width: "1em",
    height: "1em",
    viewBox: "0 0 865.8 668.07",
    style: style
  }, props), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "prefix__a",
    x1: 560.63,
    y1: 784.03,
    x2: 560.63,
    y2: 573.72,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), React.createElement("linearGradient", {
    id: "prefix__c",
    x1: 425.22,
    y1: 487.8,
    x2: 425.22,
    y2: 0,
    xlinkHref: "#prefix__a"
  }), React.createElement("linearGradient", {
    id: "prefix__b",
    x1: 808.39,
    y1: 362.48,
    x2: 808.39,
    y2: 315.28,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopOpacity: 0.12
  }), React.createElement("stop", {
    offset: 0.55,
    stopOpacity: 0.09
  }), React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.02
  })), React.createElement("linearGradient", {
    id: "prefix__d",
    x1: 808.39,
    y1: 446.62,
    x2: 808.39,
    y2: 399.42,
    xlinkHref: "#prefix__b"
  }), React.createElement("linearGradient", {
    id: "prefix__e",
    x1: 635.55,
    y1: 277.3,
    x2: 635.55,
    y2: 252.67,
    xlinkHref: "#prefix__b"
  }), React.createElement("linearGradient", {
    id: "prefix__f",
    x1: 875.32,
    y1: 446.62,
    x2: 875.32,
    y2: 399.42,
    xlinkHref: "#prefix__b"
  }), React.createElement("linearGradient", {
    id: "prefix__g",
    x1: 875.32,
    y1: 362.48,
    x2: 875.32,
    y2: 315.28,
    xlinkHref: "#prefix__b"
  }), React.createElement("linearGradient", {
    id: "prefix__h",
    x1: 713.96,
    y1: 277.3,
    x2: 713.96,
    y2: 252.67,
    xlinkHref: "#prefix__b"
  }), React.createElement("linearGradient", {
    id: "prefix__i",
    x1: 190.06,
    y1: 555.46,
    x2: 190.06,
    y2: 555.12,
    xlinkHref: "#prefix__a"
  }), React.createElement("linearGradient", {
    id: "prefix__j",
    x1: 230.49,
    y1: 770.65,
    x2: 230.49,
    y2: 548.93,
    xlinkHref: "#prefix__a"
  }), React.createElement("linearGradient", {
    id: "prefix__k",
    x1: 1098.09,
    y1: 200.15,
    x2: 1098.09,
    y2: 199.87,
    gradientTransform: "rotate(-6.74 4180.955 1285.783)",
    xlinkHref: "#prefix__a"
  }), React.createElement("linearGradient", {
    id: "prefix__l",
    x1: 1064.87,
    y1: 383.99,
    x2: 1064.87,
    y2: 194.73,
    gradientTransform: "rotate(-6.74 4180.955 1285.783)",
    xlinkHref: "#prefix__a"
  })), React.createElement("path", {
    d: "M589.32 776.61c-.49-.48-1-1-1.36-1.41a6 6 0 0 1-1.41-2.71h.36l.17-.77a73.9 73.9 0 0 0-22.17-69.9.81.81 0 0 0 .1-.18 77.15 77.15 0 0 0 .88-45.84 132.9 132.9 0 0 0 11.86-17.8c12.23-9.35 24.93-22.88 28.84-40.46a50.94 50.94 0 0 0 1-5.78c1-1 2.42-3.17.92-7.12a6.79 6.79 0 0 0-.44-.93c-.05-.09-.11-.18-.17-.26a5.77 5.77 0 0 0-.35-.51l-.23-.26a5.22 5.22 0 0 0-.37-.37l-.26-.22-.4-.28-.28-.17-.43-.21-.27-.12-.48-.16-.24-.07q-.34-.09-.68-.14a10.7 10.7 0 0 0-4.53.45s-3.6 6.24-2.19 8.62c-1.09 1.38-4 5.07-8 9.81A54 54 0 0 0 588 588a51 51 0 0 0-1.47-5.68c.53-1.32.9-3.88-2.1-6.86a6.83 6.83 0 0 0-.78-.67l-.26-.17a5.85 5.85 0 0 0-.53-.32l-.31-.14a4.94 4.94 0 0 0-.49-.19l-.32-.09-.48-.1h-1.1l-.51.05h-.25q-.35.06-.68.16a10.7 10.7 0 0 0-3.94 2.28s-.7 7.17 1.56 8.76C575.29 589.14 570 610 563 627a80 80 0 0 1-7.37 5.66v-1.54a8 8 0 0 0 0-.85 7.93 7.93 0 0 0-.13-.81l.13-.07.54-.3.78-.48.5-.32q.56-.39 1.08-.81l.41-.35c.25-.21.48-.43.72-.65l.34-.48q.43-.44.83-.92l.29-.35q.38-.47.72-1l.29-.43q.31-.48.59-1l.18-.32c.23-.43.44-.87.64-1.32l.16-.4q.22-.54.4-1.11c0-.13.09-.26.13-.39.15-.48.28-1 .38-1.48 0-.1 0-.2.05-.3q.12-.64.2-1.29v-.44c0-.53.08-1.06.08-1.61a17.55 17.55 0 0 0-2.26-8.62l.83-.22.61-.19c.23-.08.34-.15.31-.2-.43-.58-.87-1.13-1.32-1.67l-.44-.5c-.31-.36-.63-.71-1-1l-.51-.52c-.32-.31-.64-.62-1-.91l-.5-.45c-.4-.35-.8-.67-1.21-1l-.26-.21c-.49-.36-1-.7-1.47-1l-.56-.34c-.32-.2-.65-.39-1-.57l-.65-.34-.91-.44-.67-.3c-.32-.13-.65-.26-1-.37l-.61-.22c-.49-.16-1-.3-1.47-.43l-.76-.17-.81-.17-.82-.13-.75-.09-.84-.07H544.3q-.7 0-1.39.07c-10.88.89-20.4 10.39-20.4 25.48v12.54h17v5.68a17.63 17.63 0 0 0-10.24 16v48.37L515 767.95h-.07v.18l-2.8 12.48 21.21 3.39a1.09 1.09 0 0 0 .67-1.25 3.93 3.93 0 0 0-.25-1 16.83 16.83 0 0 0-1.21-2.38c-.75-1.29-1.64-2.67-2.24-3.92a8.75 8.75 0 0 1-.69-2 7.71 7.71 0 0 1-.14-1.08l15.61-51.3h-.07l.37-1.21s19.92 8.54 25 25.61c4.15 13.84 1.57 22.81.45 25.71h-.07v.17c-.22.55-.38.86-.38.86h.38v9.39h21.53c1.64-.83-.86-2.92-2.98-4.99z",
    transform: "translate(-167.1 -115.97)",
    fill: "url(#prefix__a)"
  }), React.createElement("path", {
    d: "M386.62 559.38s37.14-39.05 25-76.58l-9.74 2s-13.07 55-27 62.89 11.74 11.69 11.74 11.69z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M386.62 559.38s37.14-39.05 25-76.58l-9.74 2s-13.07 55-27 62.89 11.74 11.69 11.74 11.69z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M410.14 483.67l1.62-.33c12.1 37.53-25 76.58-25 76.58l-1.14-.19c4.28-4.7 35.81-41.06 24.52-76.06z",
    fill: "#fff",
    opacity: 0.2
  }), React.createElement("path", {
    d: "M411.18 483.78s2.7-3.36-1.53-7.57-9.41.78-9.41.78-.74 7.47 1.75 8.65 9.19-1.86 9.19-1.86z",
    fill: "#985454"
  }), React.createElement("path", {
    d: "M410.09 484.03s2.7-3.36-1.53-7.57a5.29 5.29 0 0 0-4.51-1.65 5.36 5.36 0 0 1 5.59 1.43c4.23 4.21 1.53 7.57 1.53 7.57a29.92 29.92 0 0 1-6.22 2 32.67 32.67 0 0 0 5.14-1.78z",
    fill: "#fff",
    opacity: 0.2
  }), React.createElement("rect", {
    x: 24.01,
    width: 802.42,
    height: 487.8,
    rx: 27.5,
    ry: 27.5,
    fill: "url(#prefix__c)"
  }), React.createElement("rect", {
    x: 33.12,
    y: 4.97,
    width: 781.64,
    height: 470.08,
    rx: 27.5,
    ry: 27.5,
    fill: "#fff"
  }), React.createElement("path", {
    fill: "#e0e0e0",
    d: "M94.16 78.76h22.78v64.68H94.16zM123.31 78.76h22.78v64.68h-22.78zM152.46 78.76h22.78v64.68h-22.78zM203.48 78.76h22.78v64.68h-22.78zM232.63 78.76h22.78v64.68h-22.78zM261.78 78.76h22.78v64.68h-22.78zM312.8 78.76h22.78v64.68H312.8zM341.95 78.76h22.78v64.68h-22.78zM371.1 78.76h22.78v64.68H371.1zM422.12 78.76h22.78v64.68h-22.78zM451.27 78.76h22.78v64.68h-22.78zM480.42 78.76h22.78v64.68h-22.78z"
  }), React.createElement("path", {
    fill: "#bdbdbd",
    d: "M94.16 404.9h198.6v29.15H94.16z"
  }), React.createElement("path", {
    fill: "#e0e0e0",
    d: "M94.16 355.71h344.36v29.15H94.16z"
  }), React.createElement("path", {
    d: "M827.51 361.28a4.8 4.8 0 0 1 4.62-5H839v-41h-61.2v47.2h49.72z",
    transform: "translate(-167.1 -115.97)",
    fill: "url(#prefix__b)"
  }), React.createElement("path", {
    d: "M832.13 405.58a4.8 4.8 0 0 1-4.62-5v-1.2h-49.72v47.2H839v-41z",
    transform: "translate(-167.1 -115.97)",
    fill: "url(#prefix__d)"
  }), React.createElement("path", {
    fill: "url(#prefix__e)",
    d: "M610.69 252.67h49.72v24.63h-49.72z"
  }), React.createElement("path", {
    d: "M856.2 400.62a4.8 4.8 0 0 1-4.62 5h-6.85v41h61.2v-47.2H856.2z",
    transform: "translate(-167.1 -115.97)",
    fill: "url(#prefix__f)"
  }), React.createElement("path", {
    d: "M844.72 315.28v41h6.85a4.8 4.8 0 0 1 4.62 5v1.2h49.72v-47.2z",
    transform: "translate(-167.1 -115.97)",
    fill: "url(#prefix__g)"
  }), React.createElement("path", {
    fill: "url(#prefix__h)",
    d: "M689.1 252.67h49.72v24.63H689.1z"
  }), React.createElement("path", {
    d: "M660.62 245.78a4.41 4.41 0 0 1 4.41-4.4h6.54v-36.44h-58.38v41.91h47.43zM665.03 285.1a4.41 4.41 0 0 1-4.41-4.4v-1.06h-47.43v41.91h58.37V285.1zM613.19 252.31h47.43v21.86h-47.43zM687.98 280.7a4.41 4.41 0 0 1-4.41 4.4h-6.54v36.44h58.37v-41.9h-47.42zM677.04 204.94v36.44h6.54a4.41 4.41 0 0 1 4.41 4.4v1.06h47.43v-41.9zM687.98 252.31h47.43v21.86h-47.43z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M190.23 555.46l.09-.3s-1.11-.16-.09.3z",
    transform: "translate(-167.1 -115.97)",
    fill: "url(#prefix__i)",
    opacity: 0.2
  }), React.createElement("path", {
    d: "M293.42 573.82a7.22 7.22 0 0 0-.39-1c0-.1-.11-.19-.16-.29a6.15 6.15 0 0 0-.33-.56c-.07-.1-.15-.19-.22-.29a5.55 5.55 0 0 0-.36-.42l-.26-.25c-.13-.12-.26-.23-.4-.33l-.28-.2-.44-.26-.28-.15-.5-.21-.25-.1q-.36-.12-.71-.2a11.31 11.31 0 0 0-4.81.13s-4.59 6.77-2.82 9.2l-.58-.18s-34.09 38-53.32 45.1q-.74-.5-1.53-.94v-7.11a8.4 8.4 0 0 0 0-.89 8.33 8.33 0 0 0-.14-.85l.14-.08.57-.32.83-.5.53-.34q.59-.41 1.15-.86l.43-.37c.26-.22.51-.45.76-.69l.44-.43q.46-.47.88-1l.31-.38q.4-.49.76-1l.31-.46q.33-.5.63-1l.19-.34c.24-.45.47-.92.67-1.4l.17-.42q.23-.58.43-1.17c0-.14.09-.27.14-.41.16-.51.29-1 .4-1.56 0-.1 0-.21.06-.32q.13-.67.21-1.36v-.46c.05-.56.09-1.13.09-1.7a18.56 18.56 0 0 0-4.14-11.71c1.46-2.28 2.41-3.62 2.41-3.62-.88-.6-1.74-1.16-2.6-1.68l-.83-.49c-.57-.34-1.15-.68-1.71-1l-1-.51c-.51-.27-1-.53-1.53-.78l-1-.45c-.49-.22-1-.44-1.45-.63l-1-.38c-.48-.19-1-.36-1.44-.52l-.9-.3c-.49-.16-1-.29-1.47-.42l-.8-.22c-.55-.13-1.09-.25-1.63-.35l-.58-.12c-.73-.13-1.46-.23-2.18-.3a26 26 0 0 0-13.09 2c.22-5.24 1.1-9.55 2.94-12.22l-.45-.15-.16.15s-.54.12-1.37.27a11.44 11.44 0 0 0-.71 1.33 15.23 15.23 0 0 1 2.09-5.21l-.45-.15c.65-.66 3-3.55-.16-8.27-3.61-5.41-10.23-1.2-10.23-1.2a28 28 0 0 0-1 5.46c-.51-.2-.86-.36-1.1-.48a136.34 136.34 0 0 0-5.14 34.34c-11.92 16.93-16.86 41.92-17.82 47.31l-.07.43c-.07.39-.1.6-.1.6l31 .72v49.4L175.45 736s8.55.31 21.55 2l-3.57 25.52-1.19 7.16h21.48c2.39-4.77-9.55-7.16-9.55-7.16h-.27l4.66-23.81q3.09.52 6.35 1.14a62.21 62.21 0 0 0 9.67 1.09 51.4 51.4 0 0 0 8.05-.35c1.57 12.91-.49 20.62-.89 21.94h-.13l-1.19 7.16h21.48c2.08-4.16-6.73-6.51-9-7l.1-.7a119.82 119.82 0 0 0 .85-24.31 29.42 29.42 0 0 0 7.64-4.56l.3-.26.09-.09-16-44.87c3-12.7-7.42-26-1.86-32.71s2.15-15.18 1.54-16.63c15-6.56 45.39-23 53.91-51.47a53.85 53.85 0 0 0 1.52-6.1s4.3-1.94 2.43-8.17z",
    transform: "translate(-167.1 -115.97)",
    fill: "url(#prefix__j)",
    opacity: 0.2
  }), React.createElement("path", {
    d: "M26.54 447.83s-16.29 51.37 11 79.81l7.89-6s-16.14-56.07-7.11-69.24c-15.92-5.37-11.78-4.57-11.78-4.57z",
    fill: "#ff5252"
  }), React.createElement("path", {
    d: "M37.8 452.36s3.31-2.76 0-7.73-9.38-1.1-9.38-1.1-2.21 7.17 0 8.83 9.38 0 9.38 0z",
    fill: "#f6b9ad"
  }), React.createElement("rect", {
    x: 210.69,
    y: 611.65,
    width: 15.45,
    height: 22.9,
    rx: 7.06,
    ry: 7.06,
    transform: "rotate(-180 134.865 565.12)",
    fill: "#f6b9ad"
  }), React.createElement("path", {
    d: "M44.35 524.91s-15.94-55.38-7.26-69c.77-.14 1.26-.25 1.26-.25l.14-.14.41.14c-9 13.17 7.11 69.24 7.11 69.24l-7.89 6-.69-.74z",
    fill: "#fff",
    opacity: 0.2
  }), React.createElement("circle", {
    cx: 51.04,
    cy: 486.58,
    r: 17.11,
    fill: "#f6b9ad"
  }), React.createElement("path", {
    d: "M57.11 510.86v-7.45a7.67 7.67 0 0 0-.18-1.62 17.11 17.11 0 0 0-6.86-32.29h1a17.11 17.11 0 0 1 7.83 32.29 7.67 7.67 0 0 1 .18 1.62v7.45a7.67 7.67 0 0 1-8.69 7.66 7.75 7.75 0 0 0 6.72-7.66z",
    fill: "#fff",
    opacity: 0.2
  }), React.createElement("path", {
    d: "M33.66 571.84s33 3.73 34.22 0c3.94-12.07-6.62-25.07-1.32-31.43 5.48-6.57 1.32-15.47 1.32-15.47a17.11 17.11 0 0 0-17.11-17.11 17.11 17.11 0 0 0-17.11 17.11z",
    fill: "#ff5252"
  }), React.createElement("path", {
    d: "M66.6 540.41c5.48-6.57 1.32-15.47 1.32-15.47a17.11 17.11 0 0 0-17.11-17.11c-.37 0-.73 0-1.1.06a17.09 17.09 0 0 1 16 17.05s4.16 8.9-1.32 15.47c-5.31 6.37 5.25 19.37 1.32 31.43-.38 1.15-3.78 1.59-8.3 1.65 5.58.06 10.06-.32 10.49-1.65 4-12.07-6.6-25.07-1.3-31.43z",
    fill: "#fff",
    opacity: 0.2
  }), React.createElement("path", {
    d: "M60.9 570.75c12.07 17.08 17.37 42.87 13.93 67.69l-.1.74H64.42s3.19-9.38 0-25.94a41 41 0 0 0-15.6-24.83l-9.92 50.77h-9.57l9.57-68.43zM118.9 472.33s4-1.67 2.26-7.39-8.65-3.8-8.65-3.8-4.21 6.21-2.59 8.44 8.98 2.75 8.98 2.75z",
    fill: "#f6b9ad"
  }), React.createElement("path", {
    d: "M60.34 527.69s51.26-16.61 58.56-55.36l-9.5-2.91s-37.73 42.12-53.69 42.42 4.63 15.85 4.63 15.85z",
    fill: "#ff5252"
  }), React.createElement("path", {
    d: "M117.12 472.37l1.58.49c-7.26 38.76-58.53 55.37-58.53 55.37l-.91-.71c6.03-2.12 51.09-19 57.86-55.15z",
    fill: "#fff",
    opacity: 0.2
  }), React.createElement("g", {
    opacity: 0.2,
    fill: "#fff"
  }, React.createElement("path", {
    d: "M46.63 588.4l-9.93 50.77h2.2l9.64-49.29a23.69 23.69 0 0 0-1.91-1.48zM60.9 570.75h-2.19c12.07 17.08 17.37 42.87 13.93 67.69l-.1.74h2.19l.1-.74c3.42-24.82-1.93-50.62-13.93-67.69z"
  })), React.createElement("path", {
    d: "M117.81 472.03s4-1.67 2.26-7.39a5.29 5.29 0 0 0-3.17-3.61 5.36 5.36 0 0 1 4.23 3.92c1.71 5.72-2.26 7.39-2.26 7.39a29.92 29.92 0 0 1-6.42-1.21 32.67 32.67 0 0 0 5.36.9z",
    fill: "#fff",
    opacity: 0.2
  }), React.createElement("path", {
    d: "M33.66 569.97L12.9 613.78a257.3 257.3 0 0 1 36.14 4.38c23 4.38 33.95-6.57 33.95-6.57l-14.83-41.61z",
    fill: "#263238"
  }), React.createElement("path", {
    d: "M39.18 638.97s11 2.19 8.76 6.57H28.23l1.1-6.57zM74.22 638.97s11 2.19 8.76 6.57H63.27l1.1-6.57z",
    fill: "#ff5252"
  }), React.createElement("path", {
    d: "M66.56 472.51s-26.29 37.23-14.24 52.52l-47.09-1.1s13.14-84.27 61.33-51.42z",
    fill: "#fccc63"
  }), React.createElement("path", {
    d: "M66.56 472.51c-6.79-4.63-12.88-6.93-18.34-7.47a46.36 46.36 0 0 1 12.87 6.38s-26.28 37.23-14.24 52.57l-41.45-1c-.11.62-.16 1-.16 1l47.09 1.1c-12.06-15.35 14.23-52.58 14.23-52.58zM68.15 569.97H64.9l14.83 41.61s-7.08 7.06-21.79 7.57c16.94.54 25.07-7.57 25.07-7.57zM39.18 638.97h-2.19s11 2.19 8.76 6.57h2.15c2.23-4.38-8.72-6.57-8.72-6.57zM74.22 638.97h-2.19s11 2.19 8.76 6.57h2.19c2.19-4.38-8.76-6.57-8.76-6.57z",
    fill: "#fff",
    opacity: 0.2
  }), React.createElement("path", {
    d: "M991.73 569.28l.1.24c.8-.52-.1-.24-.1-.24z",
    transform: "translate(-167.1 -115.97)",
    fill: "url(#prefix__k)",
    opacity: 0.2
  }), React.createElement("path", {
    d: "M1004.32 753l17.37-5-3.69-10.48-.05-.15h-.06l-19.36-56.17-5-42.05a15.62 15.62 0 0 0-.27-1.59c15.81-27.08 0-64.77-1.41-68.05-.18.12-.46.28-.86.5a23.06 23.06 0 0 0-1.38-4.39s-5.85-2.82-8.29 2c-2.13 4.19.07 6.34.68 6.82l-.35.17a12.61 12.61 0 0 1 2.22 4.08 9.47 9.47 0 0 0-.72-1c-.7 0-1.16-.09-1.16-.09l-.14-.11-.35.17c2.21 2.53 3.44 7.28 4 13.09a19 19 0 0 0-2.45-2.26 19.33 19.33 0 0 0-13.35-3.8l-.87.1q-.74.1-1.46.27l-.36.08-.61.16-.7.22-.5.17-.86.34-.32.14c-.35.16-.7.33-1 .51a18.88 18.88 0 0 1-3.57 1.79c-.17.05-.35.08-.52.12a6.27 6.27 0 0 1-4.22-.68l-.43-.26a5.8 5.8 0 0 1-.48-.35 2.78 2.78 0 0 0 0 1.21 3.67 3.67 0 0 0 1.56 2.32 3.47 3.47 0 0 0 .72.38 2.93 2.93 0 0 0 1.19.19 2.69 2.69 0 0 0 .41-.05l-.1.06c-.24.15-.48.29-.73.41h-.05c-.27.13-.54.25-.81.36a9.5 9.5 0 0 1-4.35.58l-.48-.06c-.24 0-.48-.07-.71-.13a5.26 5.26 0 0 0 .3.45l.11.13.23.28.13.14.25.25.14.13.3.24.12.09.44.29.15.08.32.17.21.09.28.12.23.08.28.09.23.07.32.07.39.07h2.16a5.45 5.45 0 0 0 1.58-.59c-.31.19-.63.36-1 .53l-.48.24-.5.24-.49.22-.51.21-.49.19-.53.19-.49.16-.56.17-.47.13-.61.15-.44.1-.7.13-.37.06-1.06.14a4.61 4.61 0 0 1 1.75.67 4.41 4.41 0 0 0 1.08.42 3.93 3.93 0 0 0 .5 0h1.03l.53-.07h.88a7.16 7.16 0 0 1 2.93.57 5.1 5.1 0 0 1 1.33.91c-.12.26-.24.53-.35.8s-.18.47-.26.7q-.24.71-.42 1.44a15.41 15.41 0 0 0-.31 5.38c0 .33.09.66.15 1l.05.27q.08.39.18.77v.2q.13.47.28.93l.07.18q.13.38.28.75l.09.22a15.32 15.32 0 0 0 .88 1.73l.1.17q.23.38.48.74v.07q.29.41.6.8v.06q.29.36.6.7l.07.08a15.52 15.52 0 0 0 1.45 1.39 15.49 15.49 0 0 0 4.46 2.59 6.9 6.9 0 0 0 0 .72 7 7 0 0 0 0 .74l.68 5.74q-.46.32-.9.67c-14.35-4.58-39.84-46.07-39.84-46.07l-.49.06c1.8-1.72-.94-7.92-.94-7.92a9.35 9.35 0 0 0-4-.82h-1.4l-.2.06h-.13l-.21.09h-.11l-.31.16-.29.18-.1.07-.2.15-.11.09-.17.16-.11.11-.16.17-.11.12-.16.2-.1.13-.16.25-.08.12c-.08.13-.15.26-.23.4-2.44 4.8.82 6.93.82 6.93a44.62 44.62 0 0 0 .34 5.19c3.57 32.07 40.79 52.84 42.69 53.88-.53 2.09-4.81 20.58 5 41.85a.72.72 0 0 0 .1.14 64.7 64.7 0 0 0-12.09 63.05l.22.65h.32a4.41 4.41 0 0 1-.06.45 5 5 0 0 1-.23.79 6 6 0 0 1-.66 1.26c-.29.43-.64.87-1 1.32l-.38.47c-1.54 1.86-3.09 3.67-1.72 4.17l1-.12 17.88-1.76-1-8.16h.33s-.16-.24-.42-.7v-.15h-.06c-1.28-2.41-4.44-9.95-2.25-22.4 2.7-15.37 19.14-24.84 19.14-24.84l.44 1h-.06l18.85 43v.54a7.3 7.3 0 0 1-.15 1.28 7.94 7.94 0 0 1-.26 1c-.63 1.83-1.84 4-2.29 5.63a5.15 5.15 0 0 0-.15.67 2 2 0 0 0 0 .77.89.89 0 0 0 .66.66l.24-.07.52-.15zm-20.24-126.3q-.55-.23-1.11-.41l-.63-5.37a6.92 6.92 0 0 0-.26-1.21 15.45 15.45 0 0 0 3-2.49c-.3 3.44-.66 6.66-1 9.48z",
    transform: "translate(-167.1 -115.97)",
    fill: "url(#prefix__l)",
    opacity: 0.2
  }), React.createElement("path", {
    d: "M752.63 472.74s-3.61-2.35-.91-7.67 9.19-2.2 9.19-2.2 3 6.87 1 8.77-9.28 1.1-9.28 1.1z",
    fill: "#ca7070"
  }), React.createElement("path", {
    "data-name": "<Path>",
    d: "M808.19 652.16l-15.11 1.78a5 5 0 0 1-1 4c-1.76 2.59-5.51 5.91-3.47 6.65l20.73-2.45z",
    fill: "#00695c"
  }), React.createElement("path", {
    d: "M793.21 657.86a5 5 0 0 0 1-4l-1.1.13a5 5 0 0 1-1 4c-1.76 2.59-5.51 5.91-3.47 6.65l1.1-.13c-2.03-.74 1.72-4.06 3.47-6.65z",
    fill: "#fff",
    opacity: 0.2
  }), React.createElement("path", {
    "data-name": "<Path>",
    d: "M861.62 642.68l-13.89 4a7.25 7.25 0 0 1-.05 5.05c-1.16 3.39-4.15 7.93-2 8.56l20.08-5.73z",
    fill: "#00695c"
  }), React.createElement("path", {
    d: "M832.62 456.5s22.2 49.1-1.58 80.55l-8.54-5.07s9.45-57.58-1.07-69.59c15.21-7.14 11.19-5.89 11.19-5.89z",
    fill: "#00695c"
  }), React.createElement("path", {
    d: "M821.98 462.32s-3.61-2.35-.91-7.67 9.19-2.2 9.19-2.2 3 6.87 1 8.77-9.28 1.1-9.28 1.1z",
    fill: "#ca7070"
  }), React.createElement("path", {
    d: "M848.78 651.6a7.25 7.25 0 0 0 .05-5.05l12.85-3.69-.06-.17-13.89 4a7.25 7.25 0 0 1-.05 5.05c-1.16 3.39-4.15 7.93-2 8.56l.84-.24c-1.62-.94 1.14-5.22 2.26-8.46z",
    fill: "#fff",
    opacity: 0.2
  }), React.createElement("rect", {
    x: 974.35,
    y: 622.82,
    width: 15.45,
    height: 22.9,
    rx: 7.06,
    ry: 7.06,
    transform: "rotate(-6.74 -86.378 1995.015)",
    fill: "#ca7070"
  }), React.createElement("path", {
    d: "M823.98 535.14s9.33-56.87-.88-69.36c-.78 0-1.28-.1-1.28-.1l-.16-.12-.39.18c10.52 12 1.07 69.59 1.07 69.59l8.54 5.07c.2-.27.4-.54.59-.82z",
    fill: "#fff",
    opacity: 0.2
  }), React.createElement("circle", {
    cx: 979.94,
    cy: 613.82,
    r: 17.11,
    transform: "rotate(-6.74 -88.5 1974.61)",
    fill: "#ca7070"
  }), React.createElement("path", {
    d: "M809.66 522.68l-.87-7.4a7.67 7.67 0 0 1 0-1.63 17.11 17.11 0 0 1 3-32.87l-1 .08a17.11 17.11 0 0 0-4 33 7.67 7.67 0 0 0 0 1.63l.87 7.4a7.67 7.67 0 0 0 9.53 6.59 7.75 7.75 0 0 1-7.53-6.8z",
    fill: "#fff",
    opacity: 0.2
  }), React.createElement("path", {
    d: "M840.1 580.49s-32.33 7.57-34 4c-11.57-25-5.5-46.58-5.5-46.58a17.11 17.11 0 0 1 15-19 17.11 17.11 0 0 1 19 15z",
    fill: "#00695c"
  }), React.createElement("path", {
    d: "M840.1 580.49l22.8 66.21-14.8 1.75-21.3-48.61s-18.21 10.49-21.2 27.51 3 25.76 3 25.76l-15.82 1.92-.25-.72a71.15 71.15 0 0 1 13.59-69.76",
    fill: "#263238"
  }), React.createElement("path", {
    d: "M808.04 584.28c-11.57-25-5.5-46.58-5.5-46.58a17.11 17.11 0 0 1 13.89-18.83c-.37 0-.73 0-1.1.09a17.11 17.11 0 0 0-15 19s-6.07 21.56 5.5 46.58c.59 1.27 5.11 1.12 10.68.4-4.5.47-7.96.44-8.47-.66z",
    fill: "#fff",
    opacity: 0.2
  }), React.createElement("path", {
    d: "M800.32 537.68s-47.47-25.51-47.68-64.94l9.86-1.17s29.59 48.18 45.24 51.34-7.42 14.77-7.42 14.77z",
    fill: "#00695c"
  }), React.createElement("g", {
    opacity: 0.2,
    fill: "#fff"
  }, React.createElement("path", {
    d: "M827.25 601.03l20.91 47.72 2.19-.26-21.3-48.61s-.68.37-1.8 1.15zM808.35 584.52l-2.19.26a71.15 71.15 0 0 0-13.59 69.76l.25.72 2.19-.26-.25-.72a71.15 71.15 0 0 1 13.59-69.76z"
  })), React.createElement("path", {
    d: "M754.34 473.09l-1.64.19c.21 39.43 47.68 64.94 47.68 64.94l1-.54c-5.48-3.14-46.84-27.81-47.04-64.59z",
    fill: "#fff",
    opacity: 0.2
  }), React.createElement("path", {
    d: "M798.39 491.87c1.36 2 2 4.35 2.79 6.6 1.69 4.63 4.67 9.1 9.19 11.06a17.37 17.37 0 0 0 7.88 1.18c4.07-.22 8.36-1.53 10.89-4.73a14.09 14.09 0 0 0 2.63-7.36 23.68 23.68 0 0 0-8.74-20.89c-6.26-4.8-15.35-5.76-22.27-2a20.92 20.92 0 0 1-3.95 2 6.91 6.91 0 0 1-6.25-1.29 3.82 3.82 0 0 0 4.25 4.48 10.66 10.66 0 0 1-8.07 1.4 6.93 6.93 0 0 0 9.06 2.45 23.34 23.34 0 0 1-9.59 3.16c.71-.07 2.24 1.06 3.13 1.21a18.81 18.81 0 0 0 3.28-.15 6.37 6.37 0 0 1 5.77 2.88z",
    fill: "#263238"
  }), React.createElement("g", {
    opacity: 0.2,
    fill: "#fff"
  }, React.createElement("path", {
    d: "M794.8 480.92a10.55 10.55 0 0 1-3.9 1.5 10.62 10.62 0 0 0 5-1.63 3.87 3.87 0 0 1-4.34-3.68 6.5 6.5 0 0 1-1-.67 3.82 3.82 0 0 0 4.24 4.48zM797.9 477.6a20.92 20.92 0 0 0 3.95-2 19 19 0 0 1 6.39-2.09 19.24 19.24 0 0 0-7.48 2.21 20.92 20.92 0 0 1-3.95 2c-.19.06-.39.09-.58.13a6.59 6.59 0 0 0 1.67-.25zM790.43 489.03c-.89-.15-2.42-1.28-3.13-1.21a23.34 23.34 0 0 0 9.59-3.16 6.11 6.11 0 0 1-2.15.72 23.35 23.35 0 0 1-8.54 2.57c.71-.07 2.24 1.06 3.13 1.21a7.35 7.35 0 0 0 2.3-.09 4.8 4.8 0 0 1-1.2-.04zM819.35 510.58a17.37 17.37 0 0 1-7.88-1.18c-4.52-2-7.5-6.43-9.19-11.06-.82-2.25-1.42-4.63-2.79-6.6a6.37 6.37 0 0 0-5.78-2.88 11 11 0 0 0-1.63.15h.54a6.37 6.37 0 0 1 5.78 2.88c1.36 2 2 4.35 2.79 6.6 1.69 4.63 4.67 9.1 9.19 11.06a17.37 17.37 0 0 0 7.88 1.18c.63 0 1.27-.1 1.91-.19zM794.04 485.42a7 7 0 0 1-6-2.9 10.21 10.21 0 0 1-1.32-.2 7 7 0 0 0 7.32 3.1z"
  })), React.createElement("path", {
    d: "M753.73 472.61s-3.61-2.35-.91-7.67a5.29 5.29 0 0 1 3.77-3 5.36 5.36 0 0 0-4.86 3.1c-2.71 5.32.91 7.67.91 7.67a29.92 29.92 0 0 0 6.53 0 32.67 32.67 0 0 1-5.44-.1z",
    fill: "#fff",
    opacity: 0.2
  }), React.createElement("path", {
    "data-name": "<Path>",
    d: "M403.39 652.41h15.21a5 5 0 0 0 1.44 3.91c2.05 2.37 6.16 5.22 4.23 6.2h-20.88z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M418.9 656.32a5 5 0 0 1-1.44-3.91h1.1a5 5 0 0 0 1.44 3.91c2.05 2.37 6.16 5.22 4.23 6.2h-1.1c1.96-.98-2.15-3.83-4.23-6.2z",
    fill: "#fff",
    opacity: 0.2
  }), React.createElement("path", {
    "data-name": "<Path>",
    d: "M349.21 649.27l14.26 2.33a7.25 7.25 0 0 0 .65 5c1.55 3.23 5 7.38 2.95 8.27l-20.61-3.33z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M363.02 656.62a7.25 7.25 0 0 1-.65-5l-13.2-2.16v-.17l14.26 2.33a7.25 7.25 0 0 0 .65 5c1.55 3.23 5 7.38 2.95 8.27l-.86-.14c1.59-1.12-1.67-5.05-3.15-8.13z",
    fill: "#fff",
    opacity: 0.2
  }), React.createElement("rect", {
    x: 540.32,
    y: 624.8,
    width: 15.45,
    height: 22.9,
    rx: 7.06,
    ry: 7.06,
    transform: "rotate(-180 464.495 578.265)",
    fill: "#985454"
  }), React.createElement("circle", {
    cx: 380.67,
    cy: 499.72,
    r: 17.11,
    fill: "#985454"
  }), React.createElement("path", {
    d: "M386.74 524.03v-7.45a7.67 7.67 0 0 0-.18-1.62 17.11 17.11 0 0 0-6.86-32.29h1a17.11 17.11 0 0 1 7.83 32.32 7.67 7.67 0 0 1 .18 1.62v7.42a7.67 7.67 0 0 1-8.69 7.66 7.75 7.75 0 0 0 6.72-7.66z",
    fill: "#fff",
    opacity: 0.2
  }), React.createElement("path", {
    d: "M363.29 585.03s33 3.73 34.22 0c8.55-26.21 0-46.91 0-46.91a17.11 17.11 0 0 0-17.11-17.11 17.11 17.11 0 0 0-17.11 17.02z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M363.29 585.03l-14.9 68.43h14.9l15.45-50.77s19.32 8.28 24.28 24.83 0 25.94 0 25.94h16l.16-.74a71.15 71.15 0 0 0-21.68-67.69",
    fill: "#263238"
  }), React.createElement("path", {
    d: "M395.57 585.03c8.55-26.21 0-46.91 0-46.91a17.11 17.11 0 0 0-16-17.07h1.1a17.11 17.11 0 0 1 17.11 16.98s8.55 20.69 0 46.91c-.44 1.33-4.95 1.71-10.56 1.65 4.55-.02 7.97-.45 8.35-1.56z",
    fill: "#fff",
    opacity: 0.2
  }), React.createElement("g", {
    opacity: 0.2,
    fill: "#fff"
  }, React.createElement("path", {
    d: "M378.45 603.85l-15.17 49.84h-2.21l15.45-50.77s.74.31 1.93.93zM395.29 585.26h2.21a71.15 71.15 0 0 1 21.68 67.69l-.16.74h-2.21l.16-.74a71.15 71.15 0 0 0-21.68-67.69z"
  })), React.createElement("path", {
    d: "M384.69 537.79s49.94-20.25 54.4-59.43l-9.68-2.22s-34.61 44.72-50.51 46.16 5.79 15.49 5.79 15.49z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M437.35 478.53l1.61.37c-4.46 39.18-54.4 59.43-54.4 59.43l-1-.65c5.9-2.53 49.63-22.65 53.79-59.15z",
    fill: "#fff",
    opacity: 0.2
  }), React.createElement("path", {
    d: "M438.25 479.03s3.84-1.95 1.73-7.53-8.9-3.17-8.9-3.17-3.76 6.5-2 8.61 9.17 2.09 9.17 2.09z",
    fill: "#985454"
  }), React.createElement("path", {
    d: "M437.17 478.81s3.84-1.95 1.73-7.53a5.29 5.29 0 0 0-3.43-3.36 5.36 5.36 0 0 1 4.5 3.61c2.12 5.58-1.73 7.53-1.73 7.53a29.92 29.92 0 0 1-6.49-.74 32.67 32.67 0 0 0 5.42.49z",
    fill: "#fff",
    opacity: 0.2
  }), React.createElement("path", {
    d: "M381.9 494.03l-1 23h-24.14v-12.14c0-24.52 25.92-33.83 40.52-14.12.36.48-15.38 3.26-15.38 3.26z",
    fill: "#263238"
  }), React.createElement("path", {
    d: "M376.54 480.19c6.15.51 12.46 3.85 17.45 10.59.36.48-15.33 3.29-15.33 3.29l-1.1 23h3.34l1.1-23s15.69-2.8 15.33-3.29c-5.94-7.95-13.66-11.18-20.79-10.59z",
    fill: "#fff",
    opacity: 0.2
  }));
};

UndrawCreditCardPayment.propTypes = {
  height: PropTypes.string,
  primaryColor: PropTypes.string
};
export default UndrawCreditCardPayment;